import { Link, useLocation } from "react-router-dom";
import { Bus, MessageCircle, User } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function Navbar() {
  const loc = useLocation();
  const { lang, setLang, t } = useLang();
  if (loc.pathname.startsWith("/admin")) return null;
  const waMsg = encodeURIComponent(t("nav.wa.msg"));

  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-[#DCD7D0]"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-logo">
          <div className="w-9 h-9 rounded-full bg-[#8C4A32] text-white flex items-center justify-center">
            <Bus size={18} />
          </div>
          <div className="leading-tight">
            <div className="font-serif text-xl text-stone-900">RutaEspirituana</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-stone-500">
              Sancti Spíritus · La Habana
            </div>
          </div>
        </Link>
        <div className="hidden lg:flex items-center gap-7 text-sm text-stone-700">
          <a href="/#ruta" className="hover:text-[#8C4A32]" data-testid="nav-ruta">{t("nav.ruta")}</a>
          <a href="/#nosotros" className="hover:text-[#8C4A32]" data-testid="nav-nosotros">{t("nav.nosotros")}</a>
          <a href="/#horario" className="hover:text-[#8C4A32]" data-testid="nav-horario">{t("nav.horario")}</a>
          <a href="/#pagos" className="hover:text-[#8C4A32]" data-testid="nav-pagos">{t("nav.pagos")}</a>
          <a href="/#politicas" className="hover:text-[#8C4A32]" data-testid="nav-politicas">{t("nav.cancelacion")}</a>
          <Link to="/manage" className="hover:text-[#8C4A32]" data-testid="nav-manage">{t("nav.miReserva")}</Link>
          <Link to="/cuenta" className="inline-flex items-center gap-1 hover:text-[#8C4A32]" data-testid="nav-cuenta">
            <User size={14} /> {t("nav.miCuenta")}
          </Link>
        </div>
        <div className="flex items-center gap-2">
          <LangToggle lang={lang} setLang={setLang} />
          <Link
            to="/book"
            data-testid="cta-reservar-nav"
            className="bg-[#8C4A32] hover:bg-[#6F3A27] text-white text-sm font-medium px-5 py-2.5 rounded-full transition-colors"
          >
            {t("nav.reservarColectivo")}
          </Link>
          <Link
            to="/private"
            data-testid="cta-private-nav"
            className="hidden md:inline-flex items-center gap-2 border border-[#8C4A32] text-[#8C4A32] hover:bg-[#8C4A32] hover:text-white text-sm font-medium px-4 py-2.5 rounded-full transition-colors"
          >
            {t("nav.reservarPrivada")}
          </Link>
          <a
            href={`https://wa.me/34611841896?text=${waMsg}`}
            target="_blank"
            rel="noreferrer"
            data-testid="cta-private-wa"
            className="hidden xl:inline-flex items-center gap-2 border border-[#3A5A40] text-[#3A5A40] hover:bg-[#3A5A40] hover:text-white text-sm font-medium px-4 py-2.5 rounded-full transition-colors"
          >
            <MessageCircle size={14} /> {t("nav.masEquipaje")}
          </a>
        </div>
      </div>
      {/* Mobile private trip link (visible under nav on small screens) */}
      <a
        href={`https://wa.me/34611841896?text=${waMsg}`}
        target="_blank"
        rel="noreferrer"
        data-testid="cta-private-wa-mobile"
        className="md:hidden block text-center py-2 text-xs bg-[#3A5A40] text-white"
      >
        <MessageCircle size={12} className="inline mr-1" /> {t("nav.masEquipajeMobile")}
      </a>
    </nav>
  );
}

function LangToggle({ lang, setLang }) {
  return (
    <div className="flex items-center rounded-full border border-[#DCD7D0] overflow-hidden text-xs font-medium" data-testid="lang-toggle">
      <button
        onClick={() => setLang("es")}
        data-testid="lang-es"
        className={`px-2.5 py-1.5 transition-colors ${lang === "es" ? "bg-[#8C4A32] text-white" : "text-stone-600 hover:bg-stone-100"}`}
      >
        ES
      </button>
      <button
        onClick={() => setLang("en")}
        data-testid="lang-en"
        className={`px-2.5 py-1.5 transition-colors ${lang === "en" ? "bg-[#8C4A32] text-white" : "text-stone-600 hover:bg-stone-100"}`}
      >
        EN
      </button>
    </div>
  );
}
